module.exports = __webpack_public_path__ + "static/img/login-card.01104d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/login-card.png
// module id = lc3d
// module chunks = 0